let epoch = 0;
const controllers = new Set<AbortController>();
const cleanupListeners = new Set<() => void>();

export class StaleIdentityError extends Error {
  constructor() {
    super('This response belongs to an earlier signed-in session.');
    this.name = 'StaleIdentityError';
  }
}

export function identityEpoch(): number {
  return epoch;
}

export function beginIdentityRequest(signal?: AbortSignal): { epoch: number; signal: AbortSignal; done: () => void } {
  const controller = new AbortController();
  const startedAt = epoch;
  const abort = () => controller.abort(signal?.reason);
  if (signal?.aborted) abort();
  else signal?.addEventListener('abort', abort, { once: true });
  controllers.add(controller);
  return {
    epoch: startedAt,
    signal: controller.signal,
    done: () => {
      controllers.delete(controller);
      signal?.removeEventListener('abort', abort);
    },
  };
}

export function assertCurrentIdentity(startedAt: number): void {
  if (startedAt !== epoch) throw new StaleIdentityError();
}

export function onIdentityCleanup(listener: () => void): () => void {
  cleanupListeners.add(listener);
  return () => cleanupListeners.delete(listener);
}

/** Fence all work and private browser state created by the previous identity. */
export function advanceIdentity(): void {
  epoch += 1;
  for (const controller of controllers) controller.abort();
  controllers.clear();
  for (const listener of cleanupListeners) listener();
}
